import gql from "graphql-tag";
import * as React from "react";

import type {AsyncApolloQueryResult} from "@khan/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import ApolloQuery from "#data-access/gql/apollo-query.tsx";

import type {
    publicClassroomInfoByClassCode,
    publicClassroomInfoByClassCodeVariables,
} from "./__graphql-types__/publicClassroomInfoByClassCode.ts";

type QueryResult = AsyncApolloQueryResult<
    publicClassroomInfoByClassCode,
    publicClassroomInfoByClassCodeVariables
>;

export const DATA_QUERY: GqlOperation<
    publicClassroomInfoByClassCode,
    publicClassroomInfoByClassCodeVariables
> = gqlOp(gql`
    query publicClassroomInfoByClassCode($classCode: String!) {
        joinByClassCodeInfoV2(classCode: $classCode) {
            cacheId
            name
            signupCode
            descriptor
            includesCentrallyOwnedDistrictData
            classroomDistrictInfo {
                id
                emailDomains
            }
        }
    }
`);

type Props = {
    classCode: string;
    onCompleted?: (data?: publicClassroomInfoByClassCode) => void;
    children: (result: QueryResult) => React.ReactNode;
};

class PublicClassroomInfoByClassCodeQuery extends React.Component<Props> {
    render(): React.ReactNode {
        const {classCode, children, onCompleted} = this.props;
        return (
            <ApolloQuery
                query={DATA_QUERY}
                fetchPolicy="cache-first"
                variables={{classCode}}
                onCompleted={onCompleted}
            >
                {children}
            </ApolloQuery>
        );
    }
}

export default PublicClassroomInfoByClassCodeQuery;
